var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"website-wrapper"},[_c('iframe',{attrs:{"src":_vm.src,"width":_vm.width,"height":_vm.height,"frameborder":"0"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }